// cSpell:enableCompoundWords
import GameItem from 'components/tabs/gameselect/components/gameitem/GameItem';
import SectionHeader from 'components/tabs/gameselect/components/sectionheader/SectionHeader';
import useLobbyManager from 'hooks/useLobbyManager';
import React from 'react';
import styles from './GamesSection.module.scss';

type ResumeGamesSectionProps = {
  className?: string;
};

const ResumeGamesSection: React.FC<ResumeGamesSectionProps> = ({ className = '' }) => {
  const baseCls = `${styles.SectionList} ${styles.SectionListColumn} ${className}`;

  const { resumeGamesList, onResumeGame } = useLobbyManager();

  return (
    <>
      {resumeGamesList.length > 0 && (
        <div className={baseCls}>
          <SectionHeader />
          {resumeGamesList.map((game) => {
            return <GameItem key={game.sqGameId} game={game} onGameClicked={onResumeGame} />;
          })}
        </div>
      )}
    </>
  );
};

export default ResumeGamesSection;
